import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

import { Page } from 'components';
import axios from 'utils/axios';

import {
  Header,
  Overview,
  FinancialStats,
  EarningsSegmentation,
  TopReferrals,
  MostProfitableProducts,
  LatestExams,
  Results
} from './components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  container: {
    '& > *': {
      height: '100%'
    }
  }
}));

const Dashboard = () => {
  const classes = useStyles();
  const session = useSelector(state => state.session);

  const [dataState, setDataState] = useState({
    isLoading: false,
    isLoaded: false,
  });

  const load = () => {
    axios.post(`/dashboard`).then(response => {
      if (response && !("errors" in response.data)){
        setDataState(dataState => ({
          ...dataState,
          overview: {
            income: response.data.exams_count,
            expanses: response.data.questions,
            profit: response.data.marks,
          },
          corrections: response.data.corrections,
          exams: response.data.exams,
          course_data: response.data.course_data,
          isLoading: false,
          isLoaded: true,
        }))
      }else{
        // setNotification(response.data.errors[0]);
      }
    });
  }

  const role1 = () => (<Grid
    className={classes.container}
    container
    spacing={3}
  >
    <Grid
      item
      xs={12}
    >
      <Overview data={dataState.overview}/>
    </Grid>
    
    <Grid
      item
      lg={6}
      xl={6}
      xs={12}
    >
      <FinancialStats data={dataState.course_data} />
    </Grid>
    <Grid
      item
      lg={6}
      xs={12}
    >
      <MostProfitableProducts />
    </Grid>
        {/* <Grid
      item
      lg={4}
      xl={3}
      xs={12}
    >
      <EarningsSegmentation />
    </Grid> */}
    <Grid
      item
      lg={4}
      xs={12}
    >
      <TopReferrals />
    </Grid>
    <Grid
      item
      lg={8}
      xs={12}
    >
      <LatestExams exams={dataState.exams} />
    </Grid>
    
  </Grid>);

const role3 = () => (<Grid></Grid>)
const role4 = () => {
  return (<Grid
    className={classes.container}
    container
    spacing={3}
  >
    <Grid
      item
      xs={12}
    >
      <Overview data={dataState.overview}/>
    </Grid>
    <Grid
      item
      xs={12}
    >
      {<Results
            title={"لیست تصحیح"}
            className={classes.results}
            corrections={dataState.corrections}
          />
        }
    </Grid>
  </Grid>)
}

  const selectDashboard = () => {
    switch(session.user.role) {
      case '1':
        return role1()
      case '2':
        return role1()
      case '3':
        return role3()
      case '4':
        return role4()
      default:
        // code block
    }
    
  }

  useEffect(() => {
    if(!dataState.isLoaded && !dataState.isLoading){
      setDataState(dataState => ({
        ...dataState,
        isLoading: true,
      }));
      load();
    }
  }, [dataState]);

  return !dataState.isLoaded ? React.Fragment : (
    <Page
      className={classes.root}
      title="داشبورد"
    >
      <Header />
      {selectDashboard()}
    </Page>
  );
};

export default Dashboard;
